import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

/** Loading spinner component */
export function LoadingScreen(): JSX.Element {
  return (
    <FlexBox justifyContent="center" alignItems="center" height="100%">
      <Spinner />
    </FlexBox>
  );
}
